import { Component, OnDestroy, OnInit } from "@angular/core";
import { FileUploader, FileItem, ParsedResponseHeaders } from "ng2-file-upload";
import { env } from "@env/environment";
import { DocumentoVO } from "@app/shared/vo/documentoVO";
import { ResponseUploadFileVO } from "@app/shared/vo/response-upload-fileVO";
import { Subscription } from "rxjs";
import { ControlContainer } from "@angular/forms";
import { FormFileCaricatoVO } from "@app/shared/vo/form-file-caricatoVO";
import { NotifierService } from "angular-notifier";
import { AutenticazioneService } from "@app/shared/services/autenticazione.service";
import { ISubscription } from "rxjs-compat/Subscription";

@Component({
  selector: "app-upload-file",
  templateUrl: "./upload-file.component.html",
})
export class UploadFileComponent implements OnInit, OnDestroy {
  public uploadFileFormGroup;
  public label: string;
  appo: string;
  idRepository: string;
  hash: string;
  nome: string;
  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;
  public uploader: FileUploader;
  private urlUpload = env.API_UPLOAD_BASE + env.URL_UPLOAD;
  loadingIndicator: boolean;
  public progresso: number = 0;
  listaMimeTypeConsentiti: string[];
  // documentoCaricato: DocumentoVO = new DocumentoVO();
  subscriptions: Subscription[] = [];
  messages = {
    emptyMessage: "Nessun Allegato",
    totalMessage: "in totale",
  };
  nomeFile: string;
  caricamentoEseguito: boolean = false;
  private accessToken: string;
  private utenteSubscription: ISubscription;

  constructor(
    private controlContainer: ControlContainer,
    private notifierService: NotifierService,
    private autenticazioneService: AutenticazioneService
  ) {
    this.utenteSubscription = this.autenticazioneService.utenteAnnounced$
      .filter(utente => utente != null)
      .subscribe(utente => { this.accessToken = utente.token; this.inizializzaUploader() });
    this.inizializzaUploader();
  }


  inizializzaUploader() {
    this.progresso = 0;

    this.listaMimeTypeConsentiti = [
      "application/pdf",
      // p7m
      "application/pkcs7",
      "application/pkcs7-mime",
      // m7m
      "application/x_dts_Infocert",
      // tsd
      "application/timestamp-reply",
      "application/timestamped-data",
      // zip
      "application/x-zip-compressed",
      "application/zip",
      "image/jpeg",
      "application/vnd.oasis.opendocument.text",
      "image/tiff",
      "image/jpeg",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/msword",
      "text/xml",
      "application/xml",
      "text/plain",
      "audio/mpeg",
      "video/mp4",
      "video/x-msvideo",
      "image/svg+xml",
      "text/html",
      "application/x-tika-ooxml",
      "message/rfc822",
    ];
    this.uploader = new FileUploader({
      url: this.urlUpload,
      autoUpload: true,
      authToken: "Bearer " + this.accessToken,
      allowedMimeType: this.listaMimeTypeConsentiti,
    });
    this.uploader.onWhenAddingFileFailed = (
      item: any,
      filter: any,
      options: any
    ) => {
      console.log(
        "[ModaleAggiungiUd.constructor] onAfterAddingAll, item:",
        item
      );
      if (!this.listaMimeTypeConsentiti.includes(item.type)) {
        this.notifierService.notify(
          "warning",
          "Impossibile caricare il documento, formato non consentito"
        );
      }
      this.loadingIndicator = true;
      this.messages.emptyMessage = "Upload allegato....";
    };
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.uploader.onErrorItem = (
      item: FileItem,
      response: string,
      status: number,
      headers: ParsedResponseHeaders
    ): any => {
      console.log("[ModaleAggiungiUd.constructor] response ", response);
      console.log("[ModaleAggiungiUd.constructor] item ", item);
      console.log("[ModaleAggiungiUd.constructor] status ", status);
      console.log("[ModaleAggiungiUd.constructor] headers ", headers);

      this.loadingIndicator = false;

      this.notifierService.notify(
        "warning",
        "Impossibile caricare il documento!"
      );

      this.caricamentoEseguito = true;
      this.progresso = 0;
    };

    this.uploader.onSuccessItem = (item: any, response: any) => {
      console.log("ModaleAggiungiUd.constructor] onSuccessItem: ", item.type);
      const res: ResponseUploadFileVO = <ResponseUploadFileVO>(
        JSON.parse(response)
      );
      this.idRepository = res.id;
      this.caricamentoEseguito = true;
      this.nomeFile = item.file.name;
      this.uploadFileFormGroup.setValue({
        nome: item.file.name,
        hash: res.hash,
        documentoDaSistema: false,
        controlliPrimarioAllegati: "",
        controlliNomePrimarioAllegati: "",
        controlliAllegati: "",
        idRepository: res.id,
        dataInserimento: null,
        dimensioni: null,
        bozza: false,
      });
    };

    this.uploader.onProgressItem = (fileItem: FileItem, progress: any) => {
      console.log(
        "[modale-versioni-documento][onProgressItem] " +
        fileItem +
        ", progresso: " +
        progress
      );
      this.progresso = fileItem.progress;
    };
  }

  ngOnInit() {
    this.uploadFileFormGroup = this.controlContainer.control.get(
      "fileCaricato"
    );
    this.progresso = 0;
    if (!this.uploadFileFormGroup) {
      console.log("[upload-file][onInit] : ", this.uploadFileFormGroup.value);
      this.uploadFileFormGroup = this.controlContainer.control;
    } else {
      this.idRepository = this.uploadFileFormGroup.value.idRepository;
      this.nome = this.uploadFileFormGroup.value.nome;
      this.hash = this.uploadFileFormGroup.value.hash;
    }
    if (this.nome) {
      console.log("this.nome", this.nome);
      this.nomeFile = this.nome;
    }
  }

  public reset() {
    console.log("uploaFile - reset");
    //  this.documentoCaricato = new DocumentoVO();
    this.uploadFileFormGroup.setValue({
      idRepository: "",
      nome: "",
      hash: "",
      documentoDaSistema: false,
      controlliPrimarioAllegati: "",
      controlliNomePrimarioAllegati: "",
      controlliAllegati: "",
      dataInserimento: null,
      dimensioni: null,
    });
    this.inizializzaUploader();
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public rimuoviDocumento() {
    console.log("rimuoviDocumento");
    const newValue = this.uploadFileFormGroup.value;
    newValue.idRepository = "";
    newValue.nome = "";
    newValue.hash = "";
    newValue.documentoDaSistema = false;
    newValue.dimensioni = null;
    this.uploadFileFormGroup.setValue(newValue);
    this.idRepository = "";
    this.nomeFile = "";
    this.inizializzaUploader();
  }

  public ricevoDocumento(doc: FormFileCaricatoVO) {
    // this.rimuoviDocumento();
    this.idRepository = doc.idRepository;
    this.caricamentoEseguito = true;
    this.nomeFile = doc.nome;
    this.uploadFileFormGroup.setValue({
      nome: doc.nome,
      hash: doc.hash,
      documentoDaSistema: false,
      controlliPrimarioAllegati: "",
      controlliNomePrimarioAllegati: "",
      controlliAllegati: "",
      idRepository: doc.idRepository,
      dataInserimento: null,
      dimensioni: null,
      bozza: false,
    });
  }

  ngOnDestroy(): void {
    if (this.utenteSubscription) {
      this.utenteSubscription.unsubscribe();
    }
  }
}
